module.exports = __webpack_public_path__ + "img/user-back.84bfe0be.png";